import { render } from "./SelectProduct.vue?vue&type=template&id=1e7c908b&scoped=true"
import script from "./SelectProduct.vue?vue&type=script&lang=js"
export * from "./SelectProduct.vue?vue&type=script&lang=js"

import "./SelectProduct.vue?vue&type=style&index=0&id=1e7c908b&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7c908b"]])

export default __exports__